import React, {useCallback, useEffect, useState} from "react";
import style from "../../assets/css/header.module.scss";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {selectUiState, setUiData} from "../../store/uiSlice";
import {GET_PAYMENT_URL} from "../../constants/apiConstant";
import {removeCookies} from "../../constants/helper";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import {setDataStore} from "../../store/dataSlice";
import {useDispatch, useSelector} from "react-redux";
import NoDataComponent from "../no-data";
import GlobalLogo from "../global-fields/GlobalLogo";

const MPayment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {showLoader} = useSelector(selectUiState);

  const [payUrl, setPayUrl] = useState(null);
  // Parse query parameters
  const queryParams = new URLSearchParams(location.search);

  const u_id = queryParams.get("u_id");

  const fetchPaymentURL = useCallback(async () => {
    if (!u_id) {
      // GlobalNotificationPopup({ type: "info", message: "Please Enter OTP Code." });
      return;
    }
    dispatch(setUiData({showLoader: true}));
    let data = {
      id: u_id,
    };

    const options = {
      method: GET_PAYMENT_URL.method,
      headers: GET_PAYMENT_URL.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(GET_PAYMENT_URL.url, options);
      const res = await response.json();
      if (res.status == 1) {
        // dispatch(
        //   setDataStore({
        //     // submittedProposalsData: res?.proposal_list || [],
        //     // submittedProposalsCount: res?.total_count || 0,
        //   })
        // );
        setPayUrl(res.link ?? "");
      } else {
        console.error("Error fetching proposals");
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      navigate("/");
    } finally {
      dispatch(setUiData({showLoader: false}));
    }
  }, []);
  useEffect(() => {
    fetchPaymentURL();
  }, [u_id]);
  const payUrlDummy =
    "https://secure.cardknox.com/suryainsuranceservicesllc?xAmount=1&xEmail=gaurav%40belgiumwebnet.com&xInvoice=7777&xCommand=cc%3Asale&xBillLastName=Gaurav&xBillStreet=4055%20Haward%20Avw&xBillCity=Western%20Springs&xBillState=IL&xBillZip=60558&xBillPhone=122";
  return (
    <>
      {payUrl && !showLoader ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            width: "100%",
            marginTop: 30,
          }}
        >
          <GlobalLogo logoClass={style.headerMainLogo} />
          <iframe
            src={payUrl}
            title="Associated International Brokers, Inc Payment"
            width="100%"
            height="1080px"
            style={{border: "none"}}
          ></iframe>
        </div>
      ) : (
        !showLoader && <NoDataComponent />
      )}
    </>
  );
};

export default MPayment;
